import { useStoredBoolean } from 'shared/hooks/use-stored-boolean';
import { useUser } from 'shared/hooks/use-user';

const LIFE_AREAS_OPEN_KEY_PREFIX = 'griply.side-nav-life-areas-open.';

// Per-browser (localStorage) on purpose: a nav section's fold state is not worth syncing across devices.
export const useLifeAreasSectionOpen = (): [
  boolean,
  (value: boolean) => void,
] => {
  const user = useUser();

  return useStoredBoolean(`${LIFE_AREAS_OPEN_KEY_PREFIX}${user?.uid ?? ''}`);
};
